import src from "./royale-lineup.webp"
export default { src, width: 1200, height: 1039 }
